import React from 'react';

const Alert = ({children, target, className = ""}) => {
    const defaultClass = "text-[16px] p-2 rounded-md"

    let typeClass = ""
    switch (target) {
        case "danger": typeClass = "bg-[#f9e1e5] text-[#af233a] "; break;
        case "warning": typeClass = "bg-[#fbf0da] text-[#73510d]"; break;
        case "success": typeClass = "bg-[#d6f0e0] text-[#0d6832]"; break;
        case "info": typeClass = "bg-[#a7d4ff] text-[#1c657d]"; break;
    }

    return (
        <div className={[defaultClass, typeClass, className].join(" ")}>
            {children}
        </div>
    );
};

export default Alert;